var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66634 7.66927C3.29815 7.66927 2.99967 7.96775 2.99967 8.33594C2.99967 8.70413 3.29815 9.0026 3.66634 9.0026C4.03453 9.0026 4.33301 8.70413 4.33301 8.33594C4.33301 7.96775 4.03453 7.66927 3.66634 7.66927ZM1.66634 8.33594C1.66634 7.23137 2.56177 6.33594 3.66634 6.33594C4.77091 6.33594 5.66634 7.23137 5.66634 8.33594C5.66634 9.44051 4.77091 10.3359 3.66634 10.3359C2.56177 10.3359 1.66634 9.44051 1.66634 8.33594Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.333 7.66927C9.96482 7.66927 9.66634 7.96775 9.66634 8.33594C9.66634 8.70413 9.96482 9.0026 10.333 9.0026C10.7012 9.0026 10.9997 8.70413 10.9997 8.33594C10.9997 7.96775 10.7012 7.66927 10.333 7.66927ZM8.33301 8.33594C8.33301 7.23137 9.22844 6.33594 10.333 6.33594C11.4376 6.33594 12.333 7.23137 12.333 8.33594C12.333 9.44051 11.4376 10.3359 10.333 10.3359C9.22844 10.3359 8.33301 9.44051 8.33301 8.33594Z",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 0.335938C2.0604 0.335938 1.81527 0.501905 1.71402 0.75501L0.386304 4.07431C0.351997 4.15464 0.333008 4.24307 0.333008 4.33594V8.33594C0.333008 8.70413 0.631485 9.0026 0.999674 9.0026H2.51138C2.39794 8.80649 2.33301 8.5788 2.33301 8.33594C2.33301 8.09308 2.39794 7.86539 2.51138 7.66927H1.66634V5.0026H11.6663C11.8432 5.0026 12.0127 5.07284 12.1377 5.19787C12.2628 5.32289 12.333 5.49246 12.333 5.66927V7.66927H11.488C11.6014 7.86539 11.6663 8.09308 11.6663 8.33594C11.6663 8.5788 11.6014 8.80649 11.488 9.0026H12.9997C13.3679 9.0026 13.6663 8.70413 13.6663 8.33594V5.66927C13.6663 5.13884 13.4556 4.63013 13.0806 4.25506C12.7055 3.87999 12.1968 3.66927 11.6663 3.66927H11.3201L8.85359 0.586141C8.72707 0.427997 8.53553 0.335938 8.33301 0.335938H2.33301ZM7.66634 3.66927H9.61259L8.01259 1.66927H7.66634V3.66927ZM2.78436 1.66927H6.33301V3.66927H1.98436L2.78436 1.66927Z",
    fill: "#818181"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17805 9.0026C9.0646 8.80649 8.99967 8.5788 8.99967 8.33594C8.99967 8.09308 9.0646 7.86539 9.17805 7.66927H4.8213C4.93475 7.86539 4.99967 8.09308 4.99967 8.33594C4.99967 8.5788 4.93475 8.80649 4.8213 9.0026H9.17805Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxi);
export default __webpack_public_path__ + "static/media/taxi.10f8119890bb85eaf05b69174ab02c6e.svg";
export { ForwardRef as ReactComponent };